import React, { useEffect } from 'react'
import { MenuItemWrapper } from 'src/layout/toolbar/menu-item'
import { Comments } from '@emotion-icons/fa-solid/Comments'
// import { IS_PROD } from 'src/config'

// TODO: validate IS_PROD once implemented
const COMMAND_AI_IMPLEMENTED = false

// Add this style block after your imports
const commandBarStyles = `
  #helphub-modal {
    position: absolute;
    top: 20px;
    left: 80px;
    cursor: move;
    z-index: 999;
  }
`

export const CommandAILink = () => {
  useEffect(() => {
    // Add the styles to the head
    const styleSheet = document.createElement('style')
    styleSheet.textContent = commandBarStyles
    document.head.appendChild(styleSheet)

    // Cleanup on unmount
    return () => {
      document.head.removeChild(styleSheet)
    }
  }, [])

  const onClick = (e: React.SyntheticEvent<HTMLElement>) => {
    e.stopPropagation()
    e.preventDefault()
  }

  if (!COMMAND_AI_IMPLEMENTED) {
    return null
  }

  return (
    <>
      <MenuItemWrapper onClick={onClick}>
        <Comments size="16" />
      </MenuItemWrapper>
    </>
  )
}
